module.exports = __webpack_public_path__ + "img/aa404e0c23076c7e820f560e19c2d6c5.svg";